export interface FtoReportComparisonPublicSituationRequest {
    task_id: string;
}

/**
 * 对比文献公开情况响应
 */
export type FtoReportComparisonPublicSituationResponse = {
    patent_id: string;
    related_para: string;
    pn: string;
    public_score: number;
}[];


/**
 * 新颖性报告结论 API
 */
export interface FtoReportConclusionRequest {
    task_id: string;
}

/**
 * 新颖性报告结论响应
 */
export type FtoReportConclusionResponse = boolean;

/**
 * 新颖性报告结论 API
 */
export interface FtoReportConclusionApi {
    /**
     * 获取新颖性报告结论
     * @param params 请求参数
     * @returns 新颖性报告结论
     */
    getNoveltyReportConclusion(params: FtoReportConclusionRequest): Promise<FtoReportConclusionResponse>;
}

export const FtoReportConclusionApi = Symbol.for('FtoReportConclusionApi');
